import { createReducer, on } from '@ngrx/store';
import * as ColumnStateActions from '../actions/column-state.actions';
import { ColumnState, initialColumnState } from '@store/models/column-state.model';

export const columnStateReducer = createReducer(
    initialColumnState,
    on(ColumnStateActions.setTableColumnState, (state, { tableId, columns: columns }) => {
        const newState = {
            ...state,
            tables: {
                ...state.tables,
                [tableId]: [...columns], // Replace columns for the specific tableId
            },
        };
        return newState;
    }),
    on(ColumnStateActions.resetTableColumnState, (state, { tableId }) => {
        const { [tableId]: _, ...rest } = state.tables; // Safely omit tableId from tables
        return {
            ...state,
            tables: rest,
        };
    }),
    on(ColumnStateActions.resetAllTables, () => ({
        ...initialColumnState,
    })),
);
